export const Onboard = {
	expiredContent: {
		title: "⚠️ Din onboarding-link er udløbet",
		description: `
Ups! Dette link er ikke længere aktivt. Onboarding-links udløber efter en vis periode eller kan kun bruges én gang.
Hvis du endnu ikke har opsat din konto, bed din administrator om at sende en ny invitation.
`,
		footer_content: "Hvis du allerede har fuldført onboarding, kan du",
	},
	unknow_error: {
		title: "Uventet fejl opstod",
		description: "En uventet fejl er opstået. Prøv igen senere eller kontakt support, hvis problemet fortsætter.",
	},
	form: {
		title: "Velkommen",
		description:
			"Du er blevet inviteret til at deltage i {{organizationName}} på Lens. Lad os få dig sat op og klar til at starte!",
		button_text: "Deltag i {{organizationName}}",
		button_text_loading: "Onboarding...",
	},
	login_link_text: "Log ind",
};
